
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "selectOrganization",
      resolverType: "mutation",
      routePath: "/selectOrganization",
      httpMethod: "POST",
    });
  